import styles from '../PromoSummary.module.scss';

import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from 'components/Image/Image';
import loadingGif from 'images/loading.gif';
import { LOADING_PROMO_TEST_ID } from './LoadingPromo.const';

export const LoadingPromo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(styles.promoSummaryBox, styles.promoSummaryBoxLoading)}
      data-testid={LOADING_PROMO_TEST_ID.box}
    >
      <Image src={loadingGif} alt={t('promo-code.loading')} />
    </div>
  );
};
